import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, LinearProgress, Stack } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import $data from "../../services/$data";
import { variables } from "../../styles/abstract/variables";
import { DataContext } from "../DataContext";
import TextInput from "../ui/TextInput";

function CreateProject(props) {
	const { page, onGetProjects, onShowSuccess } = useContext(DataContext);

	const [loading, setLoading] = useState(false);

	const [state, setState] = useState({
		name: '',
		address: '',
		description: '',
		med_curr_farm_practices: '',
	})

	const [status, setStatus] = useState({
		error: {},
		success: null,
	})

	const onSubmit = async () => {
		setLoading(true);

		try {
			let project = await $data.createProject(state);
			onShowSuccess(`${project.name} - farm created`);
			await onGetProjects(page);
			props.onClose();

		} catch (e) {
			setStatus({ ...status, error: e });
		} finally {
			setLoading(false);
		}
	}


	return (
		<Dialog PaperProps={{ className: 'co-background-white' }} open={props.open} onClose={props.onClose}>

			<DialogTitle color="primary">Create new farm</DialogTitle>
			<form onSubmit={(evt) => { evt.preventDefault(); onSubmit() }}>
				<DialogContent>
					<Grid container spacing={1}>
						<Grid item xs={12}>
							<TextInput value={state.name} onChange={(evt) => setState({ ...state, name: evt.target.value })} label="Name" />
						</Grid>
						<Grid item xs={12}>
							<TextInput value={state.address} onChange={(evt) => setState({ ...state, address: evt.target.value })} label="Address" />
						</Grid>
						<Grid item xs={12}>
							<TextInput rows={3} multiline value={state.description} onChange={(evt) => setState({ ...state, description: evt.target.value })} label="Description" />
						</Grid>
						<Grid item xs={12}>
							<TextInput placeholder="List of currently used farming practices" multiline rows={3} value={state.med_curr_farm_practices} onChange={(evt) => setState({ ...state, med_curr_farm_practices: evt.target.value })} label="Current Farming Practices" />
						</Grid>

					</Grid>



				</DialogContent>
				<DialogActions>
					<Button disabled={loading} style={{ lineHeight: 'unset' }} color="error" onClick={props.onClose}>Cancel</Button>
					<Button disabled={loading} type="submit" style={{ lineHeight: 'unset' }} color="primary">Create</Button>

				</DialogActions>
			</form>
			{loading && <LinearProgress color="primary" />}
		</Dialog>
	)
}

export default CreateProject;